var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useField } from '../../Components/useForm/useField';
import { InstructionType, MedicationType } from '../../Contracts/MedicationModels';
import { DaaRequired } from '../FieldSection/EditDaaSelectorField';
export function isDaaInstruction(instruction) {
    if (instruction === null)
        return false;
    return instruction.type === InstructionType.DaaInstruction;
}
export function isFreeTextInstruction(instruction) {
    if (instruction === null)
        return false;
    return instruction.type === InstructionType.FreeTextInstruction;
}
export function isDosageTimesInstruction(instruction) {
    if (instruction === null)
        return false;
    return instruction.type === InstructionType.DosageTimeInstruction;
}
export var SameInstructions;
(function (SameInstructions) {
    SameInstructions["Same"] = "same";
    SameInstructions["NotSame"] = "notSame";
})(SameInstructions || (SameInstructions = {}));
function getDaaInstructionFromDosageInstruction(dosageInstruction) {
    if (isDaaInstruction(dosageInstruction))
        return dosageInstruction;
    return {
        additionalInstructions: '',
        breakfast: '0',
        dinner: '0',
        lunch: '0',
        nightTime: '0',
        packagingType: null,
        type: InstructionType.DaaInstruction,
        textInstructions: ''
    };
}
function getFreeTextInstructions(instruction) {
    if (isFreeTextInstruction(instruction))
        return instruction;
    if (isDaaInstruction(instruction))
        return {
            type: InstructionType.FreeTextInstruction,
            // TODO: We should possible review this, but i don't think it will ever come up
            // I don't know if additional instructions is the correct value to put into instructions
            // Or if we should do a composition of the other values
            textInstructions: instruction.textInstructions,
            instructions: instruction.additionalInstructions,
            routeOfAdministration: null
        };
    if (isDosageTimesInstruction(instruction)) {
        return {
            type: InstructionType.FreeTextInstruction,
            textInstructions: instruction.textInstructions,
            instructions: instruction.instructions,
            routeOfAdministration: instruction.routeOfAdministration
        };
    }
    return {
        type: InstructionType.FreeTextInstruction,
        textInstructions: '',
        instructions: '',
        routeOfAdministration: null
    };
}
export function useEditDosageInstructionState(props) {
    var _this = this;
    var dosageInstructionField = useField({ form: props.form, field: 'dosageInstruction' });
    var orderInstructionField = useField({ form: props.form, field: 'orderInstruction' });
    var orderAndDosageInstructionSameField = useField({ form: props.form, field: 'dosageInstructionSameAsOrder' });
    var repeatsField = useField({ form: props.form, field: 'repeats' });
    var maximumSupplyPermittedField = useField({ form: props.form, field: 'maximumSupplyPermitted' });
    var minimumDaysBetweenRepeatsField = useField({ form: props.form, field: 'minimumDaysBetweenRepeats' });
    var changeDosageSameAsOrder = function (same) { return __awaiter(_this, void 0, void 0, function () {
        var freeTextInstructions;
        return __generator(this, function (_a) {
            orderAndDosageInstructionSameField.setValue(same === SameInstructions.Same, false);
            freeTextInstructions = getFreeTextInstructions(orderInstructionField.value);
            dosageInstructionField.setValue(freeTextInstructions);
            return [2 /*return*/];
        });
    }); };
    var changeMedicationType = function (type) { return __awaiter(_this, void 0, void 0, function () {
        var dosageTimesInstructionFormStructure, orderInstruction, dosageInstructionAsFreeText;
        var _a, _b;
        return __generator(this, function (_c) {
            if (type === MedicationType.TakeHomeScript) {
                dosageInstructionField.setValue(getFreeTextInstructions(dosageInstructionField.value), false);
                orderInstructionField.setValue({
                    type: InstructionType.FreeTextInstruction,
                    textInstructions: '',
                    instructions: '',
                    routeOfAdministration: null
                }, false);
                orderAndDosageInstructionSameField.setValue(false, false);
                repeatsField.setValue('0', false);
                maximumSupplyPermittedField.setValue('');
            }
            else if (type === MedicationType.MedicationOrder) {
                orderAndDosageInstructionSameField.setValue(true, false);
                dosageInstructionField.setValue(orderInstructionField.value, false);
                orderInstructionField.setValue(__assign(__assign({}, orderInstructionField.value), { type: InstructionType.FreeTextInstruction }), false);
                repeatsField.setValue('', false);
                maximumSupplyPermittedField.setValue('', false);
                minimumDaysBetweenRepeatsField.setValue(null);
            }
            else if (type === MedicationType.MedicationHistory) {
                dosageInstructionField.setValue(getFreeTextInstructions(dosageInstructionField.value), false);
                orderInstructionField.setValue({
                    type: InstructionType.FreeTextInstruction,
                    textInstructions: '',
                    instructions: '',
                    routeOfAdministration: null
                }, false);
                orderAndDosageInstructionSameField.setValue(false, false);
                maximumSupplyPermittedField.setValue('', false);
                minimumDaysBetweenRepeatsField.setValue(null);
            }
            else if (type === MedicationType.EnrmcScript) {
                repeatsField.setValue('', false);
                orderAndDosageInstructionSameField.setValue(true, false);
                minimumDaysBetweenRepeatsField.setValue(null, false);
                dosageTimesInstructionFormStructure = void 0;
                if (orderInstructionField.value.type === InstructionType.DosageTimeInstruction) {
                    dosageTimesInstructionFormStructure = orderInstructionField.value;
                }
                else {
                    dosageTimesInstructionFormStructure = {
                        type: InstructionType.DosageTimeInstruction,
                        textInstructions: orderInstructionField.value.textInstructions,
                        instructions: orderInstructionField.value.instructions,
                        routeOfAdministration: orderInstructionField.value.routeOfAdministration,
                        frequency: null,
                        times: [],
                        startsOn: ''
                    };
                    orderInstructionField.setValue(dosageTimesInstructionFormStructure, false);
                }
                orderInstruction = dosageTimesInstructionFormStructure;
                dosageInstructionAsFreeText = getFreeTextInstructions(dosageInstructionField.value);
                if (orderAndDosageInstructionSameField.value &&
                    (orderInstruction.instructions !== dosageInstructionAsFreeText.instructions ||
                        ((_a = orderInstruction.routeOfAdministration) === null || _a === void 0 ? void 0 : _a.code) !==
                            ((_b = dosageInstructionAsFreeText.routeOfAdministration) === null || _b === void 0 ? void 0 : _b.code))) {
                    dosageInstructionField.setValue(getFreeTextInstructions(orderInstruction));
                }
                else {
                    dosageInstructionField.setValue(dosageInstructionAsFreeText);
                }
            }
            return [2 /*return*/];
        });
    }); };
    var changeDaaRequired = function (type) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (type === DaaRequired.Yes) {
                dosageInstructionField.setValue(getDaaInstructionFromDosageInstruction(dosageInstructionField.value));
            }
            else {
                dosageInstructionField.setValue(getFreeTextInstructions(dosageInstructionField.value));
            }
            return [2 /*return*/];
        });
    }); };
    return {
        changeDaaRequired: changeDaaRequired,
        changeMedicationType: changeMedicationType,
        changeDosageSameAsOrder: changeDosageSameAsOrder
    };
}
